import { render, staticRenderFns } from "./AlertsInfoHeader.vue?vue&type=template&id=0296fa2f&"
import script from "./AlertsInfoHeader.vue?vue&type=script&lang=js&"
export * from "./AlertsInfoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports